import type { AppConfig } from '@org/runtime-engine';
import type { RuntimeUserRole } from '../types';

export const ROLE_LEVEL: Record<RuntimeUserRole, number> = {
  viewer: 0,
  editor: 1,
  admin: 2,
  owner: 3,
};

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const parts = token.split('.');
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    return JSON.parse(window.atob(padded)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function resolveUserIdFromToken(token: string | null, auth: AppConfig['auth'] | undefined): string | null {
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  if (!payload) return null;

  const claimKey = auth?.userIdClaim?.trim() || 'sub';
  const claimValue = payload[claimKey];
  if (typeof claimValue === 'string' && claimValue.trim()) {
    return claimValue.trim();
  }

  const fallbackSub = payload.sub;
  return typeof fallbackSub === 'string' && fallbackSub.trim() ? fallbackSub.trim() : null;
}

export function normalizeRuntimeRole(role: string | null | undefined): RuntimeUserRole {
  if (role === 'viewer' || role === 'editor' || role === 'admin' || role === 'owner') {
    return role;
  }

  return 'viewer';
}

export function hasRequiredRole(current: RuntimeUserRole, required: RuntimeUserRole): boolean {
  return ROLE_LEVEL[current] >= ROLE_LEVEL[required];
}
